import React, { useState } from 'react';
import './index.css';

const POSITIONS = {
  center: '-50%',
  left: '-80%',
  right: '0%',
};

const Dropdown = ({ title, children, position = 'center', leave }) => {
  const [open, setOpen] = useState(false);

  const handleClick = () => {
    setOpen(!open);
  };

  const handleClose = () => {
    setTimeout(() => {
      setOpen(false);
    }, 200);
  };

  const handleMouseLeave = () => {
    if (leave) {
      setOpen(false);
    }
  };

  return (
    <div className="custom-drop active" role="presentation" onBlur={handleClose}>
      <button type="button" className="drop-title admin-btn" onClick={handleClick}>
        {title}
      </button>

      {!!open && (
        <div
          className="dropdown"
          onMouseLeave={handleMouseLeave}
          style={{ transform: `translateX(${POSITIONS[position] || 0})` }}
        >
          <div className="dropdown-list">{children}</div>
        </div>
      )}
    </div>
  );
};

export default Dropdown;
